import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { scrollToTop } from '@utils/usefulFuncs';
import { createTimeInstance } from '@utils/time';

import { AI_TOOLS, FED_DOC_TYPE_MODES } from '@constants';
import { Container, H5, Page } from '@ui';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { AdvancedSettingsButton } from '@containers/DigitalAnalyst/AdvancedSettings';
import { FilterForm } from '@containers/DigitalAnalyst/components/DocFilters';
import { useGetRecentFedDocs } from '@hooks/features/useRecentFedDocs';
import { RecentFedDocsList } from '@containers/DigitalAnalyst/RecentFedDocsList';
import { FutureLiveFedEvents } from '@containers/DigitalAnalyst/LiveFedEventsList';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const defaultStartDate = createTimeInstance().subtract(2, 'months');

const defaultDocTypes = FED_DOC_TYPE_MODES.sort();

const tool = AI_TOOLS.FED_LATEST_DOCS;

export function FedRecentDocs() {
  const navigate = useNavigate();

  const [DocListComponent] = React.useState(<RecentFedDocsList key={'doc-list'} />);
  const [FutureEventsComponent] = React.useState(<FutureLiveFedEvents key={'future-events'} />);

  const [startDate, setStartDate] = React.useState(defaultStartDate);
  const [filterDocTypes, setFilterDocTypes] = React.useState(defaultDocTypes);
  const [speakers] = React.useState([]);

  useGetRecentFedDocs(startDate, filterDocTypes, speakers);

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  const onFiltersChange = (values) => {
    const { docTypes, startDate } = values;
    setFilterDocTypes(docTypes);
    setStartDate(startDate);
  };

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Page width={'1400px'}>
          <BackArrowButton onClick={onGoBack} />
          <Container top={36}>{FutureEventsComponent}</Container>
        </Page>
        <Page width={'1400px'}>
          <AdvancedSettingsButton top={8} tool={tool} />

          <Container top={0}>
            <H5>Sources</H5>
          </Container>
          <Container>
            <FilterForm docTypes={filterDocTypes} startDate={startDate} onFiltersChange={onFiltersChange} fedDocs />
          </Container>
          <Container top={24}>{DocListComponent}</Container>
        </Page>
      </Body>
    </PageWrapper>
  );
}

export default FedRecentDocs;
